module.exports = __webpack_public_path__ + "img/tcn_tcapitalnote.8db1608.png";